export const dateIntakeFormat = ['D-MMM-YYYY hh:mm:ss', 'D-MMM-YYYY', 'YYYY-MM-DDThh:mm:ss', 'YYYY-MM-DD']
